import { css } from "styled-components";

import { FontFamilies } from "styles/font-sizes/font-families/general";

export const fontStyles = css`
  * {
    font-family: ${FontFamilies.global}, sans-serif;
  }
`;
